import Commons from "./commons";

export default class Quotes extends Commons {
  constructor() {
    super();
  }

  loadComponents() {
    this.loadUsersSelect2();
    this.loadSFDC();
    this.loadSearchFormQuotes();
  }

  loadUsersSelect2() {
    const operation = this;
    $("#email").select2({
      allowClear: true,
      placeholder: "Find by Email",
      ajax: {
        url: '/get_users',
        dataType: 'json',
        data: function (params) {
          var query = {
            q: params.term,
          }
          return query;
        },
        cache: true
      }
    });
  }

  loadSFDC() {
    $("#sfdc").select2({
      allowClear: true,
      placeholder: "Find by SFDC",
      ajax: {
        url: '/get_sfdc',
        dataType: 'json',
        data: function (params) {
          var query = {
            q: params.term,
          }
          return query;
        },
        cache: true
      }
    });
  }

  loadSearchFormQuotes() {
    $("form#searchFormQuotes").bind("ajax:beforeSend", function (event, data, status, xhr) {
      $("#ajax_indicator_search").show();
    }).bind("ajax:complete", function (event, data, status, xhr) {
      $("#ajax_indicator_search").hide();
    }).bind("ajax:success", function (event, data, status, xhr) {
      $("#ajax_indicator_search").hide();
    });
  }
}
